import axios from 'axios'
import applicationConfig from '@/application.config'
import { saveAs } from 'file-saver'

axios.defaults.baseURL = applicationConfig.apiBaseUrl

axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Auth-Token, X-Requested-With, Authorization, Content-Type, Accept'
axios.defaults.headers['Access-Control-Allow-Methods'] = 'HEAD, POST, GET, PUT, PATCH, DELETE, OPTIONS'

const appService = {

  // user notifications
  getUserNotifications (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`usernotifications/user/${userId}/unread`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUserNotifications (model) {
    return new Promise((resolve, reject) => {
      axios.post(`usernotifications/update`, model)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  markNotificationAsRead (id) {
    return new Promise((resolve, reject) => {
      axios.put(`usernotifications/${id}/read`)
        .then(response => {
          resolve(response.status)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user profile
  updateUserProfile (id, profile) {
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}/profile`, profile)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getUsers () {
    return new Promise((resolve, reject) => {
      axios.get(`users`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getUser (id) {
    return new Promise((resolve, reject) => {
      axios.get(`users/${id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUserPassword (id, password) {
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}/password`, password)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBullFinderCustomers (withQueryOnly) {
    if (typeof withQueryOnly === 'undefined' || withQueryOnly === undefined) {
      withQueryOnly = false
    }
    
    return new Promise((resolve, reject) => {
      axios.get(`users/bbcustomers?withQueryOnly=${withQueryOnly}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user management
  getBeefboosterCustomer (accountNo) {
    return new Promise((resolve, reject) => {
      axios.get(`beefboosterclient/customer/${accountNo}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUser (id, user) {
    // const json = JSON.stringify(user)
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}`, user)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createUser (user) {
    return new Promise((resolve, reject) => {
      axios.post(`users`, user)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteUser (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`users/${id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateBBAccountStatus (id, accountContainer) {
    // const json = JSON.stringify(accountContainer)
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}/bbaccount`, accountContainer)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateHXAccountStatus (id, accountId) {
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}/hxaccount/${accountId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateHXAccountHerds (id, herds) {
    return new Promise((resolve, reject) => {
      axios.put(`users/${id}/hxherds`, herds)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBeefboosterCustomers () {
    return new Promise((resolve, reject) => {
      axios.get(`beefboosterclient/customers`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdtraxAccounts () {
    return new Promise((resolve, reject) => {
      axios.get(`herdtraxclient/accounts`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // herd profile
  getHerdProfile (userId, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `herdtrax/reports/herdprofile/user/${userId}`,
        timeout: 60 * 10 * 1000, // wait at least 10 minutes
        data: params
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getUserHerds (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`userherds/user/${userId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdsForSelector () {
    return new Promise((resolve, reject) => {
      axios.get(`herdtrax/herds/selector`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUserHerds (userId, herds) {
    return new Promise((resolve, reject) => {
      axios.post(`userherds/user/${userId}/update`, herds)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdYears (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`herdtrax/herdyears/user/${userId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateHerdYears (herdYear) {
    return new Promise((resolve, reject) => {
      axios.post(`herdtrax/herdyears/update`, herdYear)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // herdtrax assistant
  getHxManagerAccounts () {
    return new Promise((resolve, reject) => {
      axios.get(`herdtrax/datamanager/accounts`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  stageHerdtraxData (accountId, userId, file) {
    return new Promise((resolve, reject) => {
      axios.post(`herdtrax/datamanager/account/${accountId}/user/${userId}/stage`, file)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdtraxAnalysisExcel (accountId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `herdtrax/datamanager/account/${accountId}/analysisexcel`,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])

        // if the account ID ends in a perdiod, remove it
        var accountName
        accountName = (accountId.lastIndexOf('.') === accountId.length - 1)
          ? accountName = accountId.substring(0, accountId.length - 1)
          : accountId

        saveAs(blob, 'Cattlytics Analysis - ' + accountName + '.xlsx')
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  importHerdtraxData (accountId, userId, isBreeder) {
    return new Promise((resolve, reject) => {
      axios.get(`herdtrax/datamanager/account/${accountId}/user/${userId}/import?isBreeder=${isBreeder}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdtraxImportResult (controlId, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`herdtrax/datamanager/control/${controlId}/user/${userId}/importresult`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdtraxAssessmentExcel (accountId, controlId) {
    return new Promise((resolve, reject) => {
      axios({
        url: `herdtrax/datamanager/control/${controlId}/assessexcel`,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])

        // if the account ID ends in a perdiod, remove it
        var accountName
        accountName = (accountId.lastIndexOf('.') === accountId.length - 1)
          ? accountName = accountId.substring(0, accountId.length - 1)
          : accountId

        saveAs(blob, 'Cattlytics Assessment - ' + accountName + '.xlsx')
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // critieria
  getCriteria (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`userqueries/bullfinder/user/${userId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addRemoveTraits (id, scope, traitIds) {
    return new Promise((resolve, reject) => {
      axios.post(`userqueries/query/${id}/addremove/${scope}`, traitIds)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateCriteria (id, criteria) {
    // const json = JSON.stringify(criteria)
    if (criteria.length === 0) return
    return new Promise((resolve, reject) => {
      axios.put(`userqueries/query/${id}/update`, criteria)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addRemoveOptionalFilters (id, filterIds) {
    return new Promise((resolve, reject) => {
      axios.post(`userqueries/query/${id}/optionalfilter/addremove`, filterIds)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user queries / exports
  getBullfinderUserQueries (userId, saleId) {
    const url = ((typeof saleId === 'undefined' || saleId === undefined))
      ? `userqueries/user/${userId}/bullfinder`
      : `userqueries/user/${userId}/bullfinder?saleId=${saleId}`
      
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBullFinderExport (exportCriteria, exportFileName) {
    // const json = JSON.stringify(exportCriteria)
    return new Promise((resolve, reject) => {
      axios({
        url: `bullfinder/export`,
        dataType: 'json',
        data: exportCriteria,
        method: 'post',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])
        saveAs(blob, exportFileName + '.' + exportCriteria.fileType)
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  getForHerdSort (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`userqueries/user/${userId}/herdsort`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  queryBulls (userId, queryId, criteria) {
    // const json = JSON.stringify(criteria)
    return new Promise((resolve, reject) => {
      axios.post(`bullfinder/user/${userId}/query/${queryId}`, criteria)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  queryAnimals (userId, queryId, criteria) {
    // const json = JSON.stringify(criteria)
    return new Promise((resolve, reject) => {
      axios.post(`herdtrax/herdsort/user/${userId}/query/${queryId}`, criteria)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getHerdSortExport (exportCriteria) {
    // const json = JSON.stringify(exportCriteria)
    return new Promise((resolve, reject) => {
      axios({
        url: `herdtrax/herdsort/export`,
        dataType: 'json',
        data: exportCriteria,
        method: 'post',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])

        saveAs(blob, 'Cattlytics Herd Sort - ' + exportCriteria.title + '.' + exportCriteria.fileType)
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  getHerdSortQueries (userId, isBreeder) {
    return new Promise((resolve, reject) => {
      axios.get(`userqueries/manager/user/${userId}?isBreeder=${isBreeder}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBullFinderQueries (userId, isBreeder) {
    return new Promise((resolve, reject) => {
      axios.get(`userqueries/bullfinder/manager/user/${userId}?isBreeder=${isBreeder}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addUserQuery (query) {
    return new Promise((resolve, reject) => {
      axios.post(`userqueries`, query)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  cloneTemplateQuery (templateId, query, isBreeder) {
    return new Promise((resolve, reject) => {
      axios.post(`userqueries/clone/${templateId}?isBreeder=${isBreeder}`, query)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  initQueryFilters (queryId, filterSelections, scope) {
    // const json = JSON.stringify(filterSelections)
    return new Promise((resolve, reject) => {

      if (scope === 'herdtrax') {
        axios.post(`userqueries/query/${queryId}/filters/init`, filterSelections)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        }) 
      } else if (scope === 'bullfinder') {
        axios.post(`userqueries/bullfinder/query/${queryId}/filters/init`, filterSelections)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
      }
    })
  },

  updateUserQuery (id, query, scope) {
    //const json = JSON.stringify(query)
    const url = scope === 'herdtrax'
      ? `userqueries/${id}`
      : `userqueries/bullfinder/${id}`

    return new Promise((resolve, reject) => {
      axios.put(url, query)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteUserQuery (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`userqueries/${id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // favorite bulls
  getFavoriteBulls (userId) {
    return new Promise((resolve, reject) => {
      axios.get(`bullfinder/favoritebulls/user/${userId}?expanded=true`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  addFavoriteBull (userId, altRef, sourceId, birthYear) {
    return new Promise((resolve, reject) => {
      axios.post(`bullfinder/favoritebulls`, {
        userId: userId,
        altref: altRef,
        animalSourceId: sourceId,
        birthYear: birthYear
      }).then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteFavoriteBull (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`bullfinder/favoritebulls/${id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  //  customer invoices
  getCustomerInvoices (accountNo) {
    return new Promise((resolve, reject) => {
      axios.get(`beefboosterclient/invoices/${accountNo}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // send email
  sendNewUserAlert (emailModel) {
    return new Promise((resolve, reject) => {
      axios.post(`admin/sendmail/newuser`, emailModel)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  sendUpdateUserAlert (userModel) {
    return new Promise((resolve, reject) => {
      axios.post(`admin/sendmail/updateuser`, userModel)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // bullfinder public
  getPublicBullsByCriteria (minBirthWt, maxBirthWt, minWeanWt, maxWeanWt, minYlgWt, maxYlgWt) {
    return new Promise((resolve, reject) => {
      const instance = axios.create({
        method: 'get',
        baseURL: applicationConfig.apiBaseUrl
      })
      instance.get(`bullfinder/public?minBirthWt=${minBirthWt}&maxBirthWt=${maxBirthWt}&minWeanWt=${minWeanWt}&maxWeanWt=${maxWeanWt}&minYlgWt=${minYlgWt}&maxYlgWt=${maxYlgWt}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // animal sources
  getAnimalSources (forManager) {
    if (forManager === undefined) forManager = false
    const url = forManager ? `animalsources/manager` : `animalsources`
    
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateAnimalSource (id, source) {
    return new Promise((resolve, reject) => {
      axios.put(`animalsources/${id}`, source)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // bull finder
  getBullDetail (src, birthYear, id) {
    return new Promise((resolve, reject) => {
      //axios.get(`bullfinder/beefboosterbull/birthYear/${yob}/bull/${id}`)
      axios.get(`bullfinder/bull/${src}/${birthYear}/${id}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },  

  // sale day
  getBullFinderSales () {
    return new Promise((resolve, reject) => {
      axios.get(`bullfinder/sales`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getBeefboosterBullDetail(birthYear, bullId){
    return new Promise((resolve, reject) => {
      axios.get(`bullfinder/beefboosterbull/birthYear/${birthYear}/bull/${bullId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getSaleDaySelections(breed, isBreederDay, isTestMode){
    const testPath = isTestMode !== undefined
      ? isTestMode ? '/test' : ''
      : ''

    const url = isBreederDay !== null
      ? `beefboosterclient/selections/breed/${breed}${testPath}?isBreederDay=${isBreederDay}`
      : `beefboosterclient/selections/breed/${breed}${testPath}`

    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getSaleDateAccounts (springSaleSn) {
    return new Promise((resolve, reject) => {
      axios.get(`beefboosterclient/accounts/springsale/${springSaleSn}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // admin
  getAppSettings (saleDayModeRuleId) {
    return new Promise((resolve, reject) => {
      axios.get(`admin/settings/${saleDayModeRuleId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  enableSaleDayMode (id, enable) {
    return new Promise((resolve, reject) => {
      axios.get(`admin/rules/saledaymode/${id}/${enable}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // media
  getSourcesBreedsPhotos() {
    return new Promise((resolve, reject) => {
      axios.get(`media/photos`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getSourcesBreedsVideos() {
    return new Promise((resolve, reject) => {
      axios.get(`media/videos`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getMedia () {
    return new Promise((resolve, reject) => {
      axios.get(`media/manager`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteMediaBulk (container, blobNames) {
    return new Promise((resolve, reject) => {
      axios.post(`media/delete/${container}`, blobNames)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // bull picture
  getBullPictureBase64(sourceId, vid) {
    return new Promise((resolve, reject) => {
      axios.get(`bullfinder/bullpictures/${sourceId}/${vid}/base64`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default appService
